export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: '',
    suffixFromNow: '',
    seconds: '1m',
    minute: '1m',
    minutes: '%dm',
    hour: '1h',
    hours: '%dh',
    day: '1d',
    days: '%dd',
    month: '1me',
    months: '%dme',
    year: '1a',
    years: '%da',
    wordSeparator: ' ',
};
